export enum WizardCarPWAViews {
  DEFAULT = "default",
  HOTWIRE = "hotwire",
}
